<template>
    <div id="experiences">
        <div id="content_page">
            <experience-content />
        </div>
        <transition name="fade">
            <modal-new-experience v-if="mode === 'add'" />
            <modal-delete-experience v-if="mode === 'delete'" />
            <modal-test-experience v-if="mode === 'test'" />
        </transition>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'Experiences',
        components: {
            ModalDeleteExperience: () => import('../components/experiences/modals/ModalDeleteExperience'),
            ModalNewExperience: () => import('../components/experiences/modals/ModalNewExperience'),
            ModalTestExperience: () => import('../components/experiences/modals/ModalTestExperience'),
            ExperienceContent: () => import('../components/experiences/ExperienceContent')
        },
        computed: {
            ...mapGetters('experiences', ['mode'])
        }
    };
</script>

<style scoped>
    #content_page {
        padding: 20px;
    }
</style>
